'use client';

import { QueryKeys } from '@/constants/query-keys';
import { moviesApiService } from '@/services/(frontend)/movies/movie-api.service';
import { TheaterMovieIds } from '@cinemark/boxoffice-api-client';
import { useQuery } from '@tanstack/react-query';

export const useMovieIdsByTheater = (theaterId: number): ReturnType<typeof useQuery<TheaterMovieIds>> => {
  return useQuery<TheaterMovieIds>({
    enabled: !!theaterId,
    queryFn: async ({ signal }) => {
      const response = await moviesApiService.getMovieIdsByTheater(theaterId, signal);

      if (!response) {
        return { comingSoonMovieIds: [], nowPlayingMovieIds: [] };
      }

      return response;
    },
    queryKey: QueryKeys.global.movieIdsByTheater(theaterId),
  });
};
